import { render, staticRenderFns } from "./team-operate.vue?vue&type=template&id=5e022c52&scoped=true&"
import script from "./team-operate.vue?vue&type=script&lang=js&"
export * from "./team-operate.vue?vue&type=script&lang=js&"
import style0 from "./team-operate.vue?vue&type=style&index=0&id=5e022c52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e022c52",
  null
  
)

export default component.exports